import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { FieldSortOption } from "../../../../types/types";
import { useFieldStore } from "../../providers/FieldProvider";

type FieldSortProps = {
    onCancel: () => void;
}

export const FieldSort = ({ onCancel }: FieldSortProps) => {
    const { sortOptions, sortedBy, updateSortedBy } = useFieldStore();

    const [selectedOption, setSelectedOption] = useState<FieldSortOption>(sortedBy);

    // Function to handle the selection change
    const handleSelectChange = (event: any) => {
        const selectedValue = event.target.value;
        const selectedOption = sortOptions.find(option => option.title === selectedValue);
        if (selectedOption) {
            setSelectedOption(selectedOption);
        }
    };
    return (
        <div className="bg-white shadow-sm border-bottom border-top px-3 py-2">
            <h5 className="text-base">Sorting</h5>
            <div className="d-flex mt-2">
                <Form>
                    <Form.Control 
                        as="select"
                        size="sm"
                        value={selectedOption.title}
                        onChange={handleSelectChange}
                    >
                        {sortOptions.map((option: FieldSortOption) => (
                            <option key={option.title} value={option.title}>
                                {option.title}
                            </option>
                        ))}
                    </Form.Control>
                    <Button variant="primary" className="mt-2" size="sm" onClick={() => {
                        updateSortedBy(selectedOption);
                        onCancel();
                    }}>
                        Apply
                    </Button>
                    <Button variant="secondary" className="mt-2 ml-2" size="sm" onClick={() => {
                        onCancel();
                    }}>
                        Cancel
                    </Button>
                </Form>
            </div>
        </div>
    );
}
